<!-- Botones navegación -->
<div class="p-grid p-m-0 p-jc-center p-ai-center p-px-4 p-px-md-3 p-pt-3 bg-gris">
  <div class="p-col-12 p-sm-10 p-md-12 p-lg-10 p-xl-8 p-offset-0 p-xl-offset-1">
    <button pButton type="button" icon="pi pi-angle-left" label="Volver al inicio" routerLink="/" class="btn-primary-outline"></button>
  </div>
</div>
<!-- Fin botones navegación -->

<!-- Contenedor información general -->
<div class="p-grid p-m-0 p-jc-center p-ai-center p-px-4 p-px-md-3 p-py-2 p-py-md-3 bg-gris">
  <div class="p-col-12 p-sm-5 p-md-6 p-lg-4 p-xl-3 p-text-left" style="max-width: 360px">
    <img width="100%" style="max-width: 340px" src="assets/images/nuestros_cursos.svg" />
  </div>
  <div class="p-col-12 p-sm-7 p-md-5 p-lg-6 p-xl-5">
    <h1>Explora nuestros cursos, postula y aprueba para obtener tu certificado</h1>
    <p class="font-light">Al aprobar uno de nuestros cursos de educación continua, la Universidad de Valparaíso certifica a 
      sus estudiantes a través de insignias y certificados 100% digitales, para garantizar la validez de cada uno de nuestros programas. Conoce ahora nuestros cursos.
    </p>
  </div>
</div>
<!-- Fin contenedor información -->

<!-- Contenedor cursos gratuitos -->
<div *ngIf="!loadingGratuitos && cursosGratuitos.length" class="p-grid p-jc-center p-m-0 bg-gris-oscuro">
  <div class="p-col-11 p-sm-11 p-md-11 p-lg-10 p-xl-7">
    <div class="p-text-center">
      <h1 @fadeIn>Cursos gratuitos</h1>
      <p class="p-m-0 font-light" @fadeInUp>Estos son algunos de los cursos gratuitos, postula y realiza el curso ahora. Al aprobar el curso obtendrás tu certificado digital.</p>
    </div>
  </div>
  <div class="p-col-12 p-sm-11 p-md-12 p-lg-11 p-xl-8 p-pb-1">
    <app-cursos-carousel [cursos]="cursosGratuitos" [circular]="false" [itemsPerPage]="4" [autoplayInterval]="null"></app-cursos-carousel>
  </div>
</div>
<!-- Fin contenedor cursos gratuitos -->

<!-- Contenedor cursos de pago -->
<div *ngIf="!loadingPago && cursosDePago.length" class="p-grid p-jc-center p-m-0 bg-gris">
  <div class="p-col-11 p-sm-11 p-md-11 p-lg-10 p-xl-7">
    <div class="p-text-center">
      <h1 @fadeIn>Cursos de pago</h1>
      <p class="p-m-0 font-light" @fadeInUp>Encuentra y postula al curso de interés. Una vez realizado el pago podrás acceder al curso, y una vez que apruebes obtendrás tu certificado digital.</p>
    </div>
  </div>
  <div class="p-col-12 p-sm-11 p-md-12 p-lg-11 p-xl-8 p-pb-1">
    <app-cursos-carousel [cursos]="cursosDePago" [circular]="false" [itemsPerPage]="4" [autoplayInterval]="null"></app-cursos-carousel>
  </div>
</div>
<!-- Fin cursos de pago -->

<!-- Contenedor cursos privados empresas -->
<div *ngIf="!loadingPrivado && cursosPrivados.length" class="p-grid p-jc-center p-m-0 bg-gris">
  <div class="p-col-11 p-sm-11 p-md-11 p-lg-10 p-xl-7">
    <div class="p-text-center">
      <h1 @fadeIn>Cursos para empresas</h1>
      <p class="p-m-0 font-light" @fadeInUp>Estos son algunos de los cursos disponibles para empresas.</p>
    </div>
  </div>
  <div class="p-col-12 p-sm-11 p-md-12 p-lg-11 p-xl-8 p-pb-1">
    <app-cursos-carousel [cursos]="cursosPrivados" [circular]="false" [itemsPerPage]="4" [autoplayInterval]="null"></app-cursos-carousel>
  </div>
</div>
<!-- Fin contenedor cursos privados -->

<!-- Contenedor todos los cursos -->
<div *ngIf="!loadingCursos && cursos.length" class="p-grid p-jc-center p-m-0 bg-gris-oscuro">
  <div class="p-col-12 p-sm-11 p-md-10 p-lg-10 p-xl-9 p-py-3">
    <div class="p-text-center">
      <h1 @fadeIn>Todos los cursos</h1>
      <p @fadeInUp class="font-light">Aquí encontrarás todos los cursos disponibles. Para más detalles, accede al curso de interés.</p>
    </div>
  </div>
  <div class="p-col-12 p-sm-11 p-md-10 p-lg-9 p-xl-9 p-py-3" style="max-width: 1160px;">
    <app-cursos-grid [cursos]="cursos" [filtros]="true" [pagination]="true" [onePagePagination]="true" [itemsPerPage]="8"></app-cursos-grid>
  </div>
</div>
<!-- Fin contenedor todos los cursos -->